import { ReactNode } from "react";
import {
  LuSquarePen,
  LuDiamondPlus,
  LuChartPie,
  LuPalette,
  LuSparkles,
  LuShapes,
  LuQrCode,
  LuLayoutGrid,
  LuLayoutDashboard,
} from "react-icons/lu";
import { AccordionIconName } from "../types";
import { MdRoundedCorner } from "react-icons/md";

export const ICON_MAP = {
  LuSquarePen: <LuSquarePen />,
  LuDiamondPlus: <LuDiamondPlus />,
  LuChartPie: <LuChartPie />,
  LuPalette: <LuPalette />,
  LuSparkles: <LuSparkles />,
  LuLayoutDashboard: <LuLayoutDashboard />,
  LuShapes: <LuShapes />,
  LuQRcode: <LuQrCode />,
  MdRoundedCorner: <MdRoundedCorner />,
  LuLayoutGrid: <LuLayoutGrid className="icon-rotate-45" />,
} as const satisfies Record<string, ReactNode>;

export const getAccordionIcon = (icon?: AccordionIconName | ReactNode) => {
  if (!icon) return undefined;
  return typeof icon === "string" ? ICON_MAP[icon as keyof typeof ICON_MAP] : icon;
};
